import React from "react";
import i18n from "./i18n";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {I18nextProvider} from "react-i18next";
import './styles/App.css';
import './styles/Register.css';
import {GlobalAlertRegion, GlobalToastRegion, ThemeProvider, ToastProvider,} from "@connectme2/ui";
import WelcomePage from "./page/WelcomePage";
import RegisterPage from "./page/RegisterPage";
import brandingData from './brandings/dstny/dstny.json'
import ValidationPage from "./page/ValidationPage";


function App() {

    localStorage.setItem("CONNECTME_BRANDING_MANIFEST", JSON.stringify(brandingData))
    return (
        <div className='App'>
            <ThemeProvider>
                <ToastProvider>
                    <I18nextProvider i18n={i18n}>
                        <Router>
                            <Routes>
                                <Route path="/" element={<WelcomePage/>}/>
                                <Route path="/register" element={<RegisterPage/>}/>
                                <Route path="/validate/:token" element={<ValidationPage/>}/>
                            </Routes>
                        </Router>
                        <GlobalToastRegion/>
                        <GlobalAlertRegion/>
                    </I18nextProvider>
                </ToastProvider>
            </ThemeProvider>
        </div>
    );
}

export default App;
